import { useState } from 'react'
import { Check, Loader2, ArrowRight } from 'lucide-react'
import { subscribeAssistantPlan } from '@/services/assistant-plan'
import PriceDescription from './price-description'
import PriceDisplay from './price-display'

const PlanCard = ({ plan = {} }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const { plan_type, name, description, price, period, price_description, features, recommended } = plan
  const hasFeatures = features?.length > 0

  const handleSubscribe = async () => {
    if (loading) return
    setLoading(true)
    setError(null)
    try {
      const currentUrl = window.location.href
      const { data } = await subscribeAssistantPlan(plan_type, {
        successURL: currentUrl,
        cancelURL: currentUrl,
      })
      if (data?.URL) {
        window.location.href = data.URL
      } else {
        setError('Erro ao gerar link de pagamento')
      }
    } catch (err) {
      let msg = 'Erro ao processar assinatura. Tente novamente.'
      if (typeof err === 'string') msg = err
      else if (err?.status === 403) msg = 'Você não tem permissão para realizar essa assinatura.'
      else if (err?.data?.message) msg = err.data.message
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="relative flex h-full flex-col rounded-xl p-4 sm:p-5"
      style={{
        background: recommended ? 'rgba(26,14,36,0.7)' : 'rgba(255,255,255,0.02)',
        border: recommended ? '1px solid rgba(173,52,254,0.35)' : '1px solid rgba(255,255,255,0.07)',
      }}
    >
      <div className="flex items-center justify-between gap-2">
        <span
          className="text-[10px] font-medium uppercase tracking-wider"
          style={{ color: 'rgba(255,255,255,0.35)' }}
        >
          Plano
        </span>
        {recommended && (
          <span
            className="rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wider"
            style={{
              color: '#AD34FE',
              background: 'rgba(173,52,254,0.1)',
              border: '1px solid rgba(173,52,254,0.2)',
            }}
          >
            Recomendado
          </span>
        )}
      </div>

      <h3 className="mt-2.5 text-[15px] font-semibold leading-tight" style={{ color: '#fff' }}>
        {name}
      </h3>

      {description && (
        <p className="mt-1 text-xs leading-snug" style={{ color: 'rgba(255,255,255,0.45)' }}>
          {description}
        </p>
      )}

      {hasFeatures && (
        <>
          <div className="my-3 h-px w-full" style={{ background: 'rgba(255,255,255,0.07)' }} />
          <ul className="flex flex-col gap-2">
            {features.map((feature, index) => (
              <li
                key={`${feature.substring(0, 12)}-${index}`}
                className="flex items-start gap-2 text-[12px] leading-snug"
                style={{ color: 'rgba(255,255,255,0.7)' }}
              >
                <Check className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" strokeWidth={2.5} style={{ color: '#AD34FE' }} />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </>
      )}

      <div className="mt-auto flex flex-col gap-2.5 pt-4">
        <div className="flex flex-col">
          <PriceDisplay price={price} period={period} />
          <PriceDescription description={price_description} />
        </div>

        <button
          type="button"
          onClick={handleSubscribe}
          disabled={loading}
          className="flex h-9 w-full items-center justify-center gap-1.5 rounded-lg text-[13px] font-semibold transition-all active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
          style={{
            color: '#fff',
            background: loading
              ? 'rgba(173,52,254,0.4)'
              : recommended
                ? 'linear-gradient(135deg, #AD34FE 0%, #7b1fd4 100%)'
                : 'rgba(255,255,255,0.04)',
            boxShadow: recommended && !loading ? '0 0 20px rgba(173,52,254,0.3)' : 'none',
            border: recommended ? 'none' : '1px solid rgba(255,255,255,0.09)',
          }}
        >
          {loading ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <>
              <span>Assinar agora</span>
              <ArrowRight className="h-3.5 w-3.5" />
            </>
          )}
        </button>

        {error && (
          <p role="alert" className="text-center text-[11px] font-medium" style={{ color: '#fca5a5' }}>
            {error}
          </p>
        )}
      </div>
    </div>
  )
}

export default PlanCard
